import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'src/utils/twMerge';
import useNavigateBack from 'src/hooks/useNavigateBack';
import { createLocalIcon } from 'src/designSystem/LocalIcon';
import BackArrowSvg from 'src/assets/onboarding/back-arrow.svg?react';
import CornerIconButton from 'src/designSystem/CornerIconButton';

const BackArrowIcon = createLocalIcon(BackArrowSvg);

type Props = {
  onClick?: () => void;
  from?: string;
  className?: string;
};

const BackArrowButton: FunctionComponent<Props> = ({
  onClick,
  from,
  className,
}) => {
  const { t } = useTranslation();
  const goBack = useNavigateBack({ from });

  return (
    <CornerIconButton
      aria-label={t('global.back')}
      onClick={() => (onClick ?? goBack)()}
      data-testid="btn-back"
      icon={<BackArrowIcon className={twMerge('w-6 h-6', className)} />}
    />
  );
};

export default BackArrowButton;
